export default {"src":"/_next/static/media/PURPLE_INFO.8fa880a4.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};